import React, { useState, useEffect, useContext } from "react";
import {
  Typography,
  Input,
  Button,
  Dropdown,
  Menu,
  Icon,
  message,
  Result,
} from "antd";
import { platformApi } from "../../../api";

import VehicleSaleInvoiceTable from "./VehicleSaleInvoiceTable";
import VehicleSaleModal from "./VehicleSaleModal";
import { useBranch } from "../../../ContextAPI/branch";
import { ContextAPI } from "../../../ContextAPI";

const { Title } = Typography;
const { Search } = Input;
const { Item } = Menu;

export default function VehicleSaleInvoice() {
  const { selectBranch } = useBranch();
  const [limit, setLimit] = useState(10);
  const [dataSource, setData] = useState([]);
  const [count, setCount] = useState();
  const [modalVisible, setModalVisible] = useState(false);
  const [editData, setEditData] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const { loginCredintials } = useContext(ContextAPI)
  const [modifyAccess, setModifyAccess] = useState(false);
  const [printAccess, setPrintAccess] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => {
    loginCredintials.roleAccess && loginCredintials.roleAccess.map(each => {
      if (each.subModule === 'VEHICLESALEINVOICE') {
        if (each.access.update) {
          setModifyAccess(true)
        }
        if (each.access.print) {
          setPrintAccess(true)
        }
      }
    })
  }, []);

  useEffect(() => {
    if (selectBranch) {
      setPage(1);
      getData(1, limit, search);
    }
  }, [selectBranch]);

  const getData = (p = page, l = limit, s = search) => {
    platformApi
      .post(`/api/saleInvoice/get`, {
        branch: Array.isArray(selectBranch) ? selectBranch.map((b) => b.id) : [],
        page: p,
        size: l,
        searchString: s,
      })
      .then((res) => {
        const responseData = res.data.response.data || res.data.response;
        setCount(responseData.count);
        setData(responseData.SaleInvoice);
      });
  };

  const getMenu = () => {
    const menus = [10, 20, 50];
    return menus.map((menu) => (
      <Item
        onClick={() => {
          setLimit(menu);
          setPage(1);
          getData(1, menu, search);
        }}
        key={menu}
      >
        {menu}
      </Item>
    ));
  };

  const menu = <Menu>{getMenu()}</Menu>;

  const handleModify = (id) => {
    platformApi.get(`/api/saleInvoice/${id}`).then((res) => {
      let result = res.data.response.data || res.data.response;
      setEditData({ ...result, hypothecation: (result.saleRegister?.saleData?.loan) ? result.saleRegister?.saleData?.loan?.hypothecation : result?.hypothecation });

      setIsEdit(true);
      setModalVisible(true);
    });
  };

  const handleAdd = () => {
    setEditData(null);
    setIsEdit(false);
    setModalVisible(true);
  };

  const handleCloseModal = () => {
    setEditData(null);
    setModalVisible(false);
    setIsEdit(false);
    getData();
  };

  return (
    <div>
      <div className="accessories-head">
        <div style={{ display: "flex", alignItems: "center", gap: "15px", width: "60%" }}>
          <Title style={{ margin: 0 }} level={4}>
            Vehicle Sale Invoice [{count || 0}]
          </Title>
          <Dropdown overlay={menu} trigger={["click"]}>
            <Button>
              {limit} &nbsp;
              <Icon type="down" />
            </Button>
          </Dropdown>
        </div>
        <Search
          style={{ width: "30%" }}
          placeholder="Search Vehicle"
          onSearch={(value) => {
            setSearch(value);
            setPage(1);
            getData(1, limit, value);
          }}
          onChange={(e) => {
            setSearch(e.target.value);
            if (e.target.value === "") {
              setPage(1);
              getData(1, limit, "");
            }
          }}
        />
      </div>
      <VehicleSaleInvoiceTable
        dataSource={dataSource}
        onModify={handleModify}
        modifyAccess={modifyAccess}
        printAccess={printAccess}
        pagination={{
          current: page,
          pageSize: limit,
          total: count,
          onChange: (p, l) => {
            setPage(p);
            setLimit(l);
            getData(p, l, search);
          },
        }}
      />
      {modalVisible && editData && (
        <VehicleSaleModal
          open={modalVisible}
          close={handleCloseModal}
          dataSource={editData}
          isEdit={isEdit}
        />
      )}
    </div>
  );
}
